var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.76757 0L7.71441 1.12764L10.1555 3.71696L0 3.72785L0.00150243 5.31885L10.1292 5.30798L7.7292 7.87763L8.78731 9L13 4.48948L8.76757 0Z","fill":"black"}));
}

ArrowRight.defaultProps = {"width":"13","height":"9","viewBox":"0 0 13 9","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
